{
  "_note": "REVIEW NEEDED: IRB/regulatory terminology must be reviewed by a qualified French-speaking clinical research professional before activating locale=fr in production.",
  "app": {
    "name": "OneVerse",
    "loading": "Chargement...",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "confirm": "Confirmer",
    "submit": "Soumettre",
    "edit": "Modifier",
    "close": "Fermer",
    "back": "Retour",
    "next": "Suivant",
    "search": "Rechercher",
    "filter": "Filtrer",
    "export": "Exporter",
    "yes": "Oui",
    "no": "Non",
    "required": "Obligatoire",
    "optional": "Facultatif",
    "none": "Aucun",
    "unknown": "Inconnu",
    "error": "Une erreur est survenue. Veuillez réessayer.",
    "powered_by": "Propulsé par {{name}}"
  },
  "nav": {
    "home": "Accueil",
    "dashboard": "Tableau de bord",
    "submissions": "Soumissions",
    "studies": "Études",
    "sites": "Sites",
    "users": "Utilisateurs",
    "settings": "Paramètres",
    "notifications": "Notifications",
    "admin": "Administration",
    "help": "Aide",
    "sign_out": "Déconnexion",
    "logout": "Se déconnecter",
    "expand_sidebar": "Développer la barre latérale",
    "collapse_sidebar": "Réduire la barre latérale"
  },
  "auth": {
    "sign_in": "Se connecter",
    "sign_in_button": "Se connecter",
    "sign_out": "Se déconnecter",
    "email": "Adresse e-mail",
    "email_placeholder": "Entrez votre adresse e-mail",
    "password": "Mot de passe",
    "password_placeholder": "Entrez votre mot de passe",
    "forgot_password": "Mot de passe oublié ?",
    "reset_password": "Réinitialiser le mot de passe",
    "enter_reset_code": "Entrez le code de réinitialisation",
    "reset_code_instructions": "Entrez votre adresse e-mail et nous vous enverrons un code pour réinitialiser votre mot de passe.",
    "new_code_instructions": "Entrez le code et votre nouveau mot de passe.",
    "send_reset_code": "Envoyer le code de réinitialisation",
    "sending": "Envoi en cours...",
    "reset_password_action": "Réinitialiser le mot de passe",
    "resetting": "Réinitialisation en cours...",
    "create_account": "Créer un compte",
    "welcome": "Bienvenue sur OneVerse",
    "remember_password": "Vous vous souvenez de votre mot de passe ?",
    "confirmation_code": "Code de confirmation",
    "confirmation_code_placeholder": "Entrez le code reçu par e-mail ou SMS",
    "new_password": "Nouveau mot de passe",
    "new_password_placeholder": "Entrez votre nouveau mot de passe",
    "confirm_password": "Confirmer le nouveau mot de passe",
    "confirm_password_placeholder": "Confirmez votre nouveau mot de passe",
    "mfa": {
      "code": "Code",
      "back_to_login": "Retour à la connexion",
      "sms_placeholder": "Entrez le code envoyé sur votre téléphone",
      "email_placeholder": "Entrez le code envoyé sur votre e-mail",
      "totp_placeholder": "Entrez le code de votre application d'authentification"
    },
    "show_password": "Afficher le mot de passe",
    "hide_password": "Masquer le mot de passe",
    "errors": {
      "invalid_credentials": "E-mail ou mot de passe invalide.",
      "account_locked": "Votre compte a été bloqué. Veuillez contacter le support.",
      "session_expired": "Votre session a expiré. Veuillez vous reconnecter.",
      "email_required": "L'adresse e-mail est obligatoire",
      "email_password_required": "L'adresse e-mail et le mot de passe sont obligatoires",
      "all_fields_required": "Tous les champs sont obligatoires",
      "passwords_dont_match": "Les mots de passe ne correspondent pas",
      "unexpected": "Une erreur inattendue est survenue",
      "server_non_json": "Le serveur a renvoyé une réponse non-JSON. Vérifiez la console."
    },
    "welcome_back": "Bon retour",
    "subtitle": "Veuillez saisir vos informations.",
    "no_account": "Pas de compte ?",
    "sign_up": "S'inscrire"
  },
  "dashboard": {
    "welcome": "Bienvenue, {{name}}",
    "new_submission": "Nouvelle soumission",
    "submission_overview": "Vue d'ensemble des soumissions",
    "view_all_submissions": "Voir toutes les soumissions",
    "recent_activity": "Activité récente",
    "no_recent_activities": "Aucune activité récente.",
    "search_placeholder": "Rechercher",
    "total": "Total",
    "submission_singular": "soumission",
    "submission_plural": "soumissions",
    "active_site_status": "État des sites actifs",
    "view_study": "Voir l'étude",
    "loading_studies": "Chargement des études...",
    "select_study": "Sélectionner une étude",
    "view_details": "Voir les détails",
    "news_and_notes": "Actualités et notes",
    "no_recent_posts": "Aucune publication récente.",
    "failed_to_load_announcements": "Échec du chargement des annonces",
    "statuses": {
      "response_required": "Réponse requise",
      "drafts": "Brouillons",
      "submitted": "Soumis",
      "pre_review": "Pré-révision",
      "irb_review": "Révision IRB",
      "post_review": "Post-révision",
      "expiring_soon": "Expire bientôt"
    }
  },
  "submissions": {
    "title": "Soumissions",
    "new": "Nouvelle soumission",
    "empty": "Aucune soumission trouvée.",
    "status": {
      "pending": "En attente",
      "under_review": "En cours de révision",
      "approved": "Approuvé",
      "rejected": "Rejeté",
      "revisions_required": "Révisions requises",
      "withdrawn": "Retiré",
      "expired": "Expiré",
      "closed": "Fermé",
      "draft": "Brouillon",
      "submitted": "Soumis",
      "pre_review": "Pré-révision",
      "irb_review": "Révision IRB",
      "post_review": "Post-révision",
      "response_required": "Réponse requise",
      "expiring_soon": "Expire bientôt",
      "complete": "Terminé",
      "deleted": "Supprimé"
    },
    "fields": {
      "title": "Titre",
      "protocol_number": "Numéro de protocole",
      "principal_investigator": "Investigateur principal",
      "submitted_at": "Soumis le",
      "updated_at": "Dernière mise à jour",
      "status": "Statut",
      "type": "Type",
      "id": "ID",
      "submitted": "Soumis",
      "expiration": "Date d'expiration"
    },
    "actions": {
      "view": "Voir la soumission",
      "edit": "Modifier la soumission",
      "withdraw": "Retirer",
      "submit": "Soumettre pour révision"
    },
    "empty_yet": "Aucune soumission pour l'instant.",
    "search_placeholder": "Rechercher par ID ou titre",
    "filter": {
      "all_statuses": "Tous les statuts",
      "all_types": "Tous les types",
      "status_label": "Statut",
      "type_label": "Type"
    },
    "errors": {
      "failed_to_load": "Échec du chargement des soumissions"
    }
  },
  "studies": {
    "title": "Études",
    "new": "Nouvelle étude",
    "empty": "Aucune étude trouvée.",
    "fields": {
      "title": "Titre de l'étude",
      "irb_number": "Numéro IRB",
      "pi": "Investigateur principal",
      "status": "Statut",
      "start_date": "Date de début",
      "end_date": "Date de fin",
      "id": "ID",
      "type": "Type",
      "submitted": "Soumis",
      "expiration": "Date d'expiration"
    },
    "empty_yet": "Aucune étude pour l'instant.",
    "search_placeholder": "Rechercher par ID ou titre",
    "filter": {
      "all_statuses": "Tous les statuts",
      "all_types": "Tous les types",
      "type_label": "Type",
      "attribute_label": "Attribut",
      "all_attributes": "Tous les attributs",
      "attribute_value_placeholder": "Valeur de l'attribut"
    },
    "errors": {
      "failed_to_load": "Échec du chargement des études"
    },
    "standalone": "autonome",
    "sort_by": "Trier par {{column}}",
    "attributes": {
      "cro": "CRO",
      "sponsor": "Promoteur",
      "pi": "PI",
      "pi_email": "E-mail du PI",
      "poc": "POC",
      "poc_email": "E-mail du POC",
      "poc_phone": "Téléphone du POC",
      "poc_role": "Rôle du POC"
    }
  },
  "sites": {
    "title": "Sites",
    "new": "Nouveau site",
    "empty": "Aucun site trouvé.",
    "empty_yet": "Aucun site pour l'instant.",
    "search_placeholder": "Rechercher par ID, nom du site ou PI",
    "filter": {
      "all_statuses": "Tous les statuts",
      "all_countries": "Tous les pays",
      "country_label": "Pays"
    },
    "errors": {
      "failed_to_load": "Échec du chargement des sites"
    },
    "fields": {
      "id": "ID",
      "site_name": "Nom du site",
      "country": "Pays",
      "protocol_number": "Numéro de protocole",
      "sponsor_name": "Nom du promoteur",
      "pi_name": "Nom du PI",
      "approved": "Approuvé",
      "expiration": "Date d'expiration",
      "status": "Statut"
    }
  },
  "errors": {
    "not_found": "La ressource demandée est introuvable.",
    "unauthorized": "Vous n'êtes pas autorisé à effectuer cette action.",
    "server_error": "Une erreur serveur est survenue. Veuillez réessayer plus tard.",
    "network_error": "Une erreur réseau est survenue. Vérifiez votre connexion.",
    "not_found_title": "Nous avons perdu cette page",
    "not_found_body": "La page que vous recherchez n'existe pas ou a été déplacée.",
    "go_back": "Retour"
  },
  "pagination": {
    "previous": "Précédent",
    "next": "Suivant",
    "page": "Page {{current}} sur {{total}}",
    "showing": "Affichage de {{from}}–{{to}} sur {{total}}"
  },
  "dates": {
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "just_now": "À l'instant",
    "ago": "Il y a {{time}}"
  },
  "entity": {
    "status": {
      "in_progress": "En cours",
      "active": "Actif",
      "rejected": "Rejeté",
      "suspended": "Suspendu",
      "closed": "Fermé",
      "expired": "Expiré"
    }
  },
  "activities": {
    "submission_approved": "Soumission approuvée",
    "submission_created": "Soumission créée",
    "submission_submitted": "Soumission envoyée",
    "submission_updated": "Soumission mise à jour",
    "submission_withdrawn": "Soumission retirée",
    "submission_rejected": "Soumission rejetée",
    "submission_expired": "Soumission expirée",
    "study_created": "Étude créée",
    "study_updated": "Étude mise à jour",
    "site_created": "Site créé",
    "site_updated": "Site mis à jour",
    "status_changed": "Statut modifié",
    "review_started": "Examen démarré",
    "review_completed": "Examen terminé",
    "comment_added": "Commentaire ajouté",
    "document_uploaded": "Document téléchargé",
    "response_required": "Réponse requise"
  }
}
